<template>
  <FormContainer>
    <template #title>Coordonnées du représentant légal</template>

    <template #content>
      <div class="form__bloc">
        <WrapperToggleSwitch
          id="field_55.5"
          v-model="estMemeAddresseRepresentantLegal"
          label="L'adresse du représentant légal est-elle la même que celle de l'apprenti ?"
          :items="OuiOuNon"
          :readonly
          :disabled="representantLegalDisabled"
          class="col-10 col-md-14 col-sm-36"
        />
      </div>

      <div class="form__bloc">
        <template v-if="estMemeAddresseRepresentantLegal">
          <WrapperInput
            id="field_47"
            :model-value="model?.apprenti?.adresse?.voie"
            :label="LABEL_NUMERO_VOIE"
            class="col-12 col-md-18 col-sm-36"
            placeholder="Ex : 10 impasse GRANET"
            disabled
          />
          <WrapperInput
            id="field_47"
            :model-value="model?.apprenti?.adresse?.complement"
            label="Complément d'adresse"
            class="col-12 col-md-18 col-sm-36"
            placeholder="Ex : Bâtiment B"
            disabled
          />
          <WrapperInput
            id="field_48"
            :model-value="model?.apprenti?.adresse?.codePostal"
            label="Code postal"
            class="col-4 col-md-6 col-sm-36"
            placeholder="Ex : 75001"
            disabled
          />
          <WrapperInput
            id="field_49"
            :model-value="model?.apprenti?.adresse?.commune"
            label="Commune"
            class="col-8 col-md-12 col-sm-36"
            placeholder="Ex : Paris"
            disabled
          />
        </template>
        <template v-else>
          <WrapperInput
            id="field_57"
            v-model="voieModel"
            :label="LABEL_NUMERO_VOIE"
            class="col-12 col-md-18 col-sm-36"
            placeholder="Ex : 10 impasse GRANET"
            :required="meta.representantLegal?.adresse?.voie?.$status === PropertyStatus.Required"
            :alertLabel="meta.representantLegal?.adresse?.voie?.$messageErreurDirty!"
            :maxlength="38"
            deletable
            :readonly
            :disabled="representantLegalDisabled"
          />
          <WrapperInput
            id="field_57"
            v-model="complementAdresseRepresentantModel"
            label="Complément d'adresse"
            class="col-12 col-md-18 col-sm-36"
            placeholder="Ex : Bâtiment B"
            :required="meta.representantLegal?.adresse?.complement?.$status === PropertyStatus.Required"
            :alertLabel="meta.representantLegal?.adresse?.complement?.$messageErreurDirty!"
            :maxlength="38"
            deletable
            :readonly
            :disabled="representantLegalDisabled"
          />
          <WrapperInput
            id="field_58"
            v-model="codePostalRepresentantModel"
            label="Code postal"
            class="col-4 col-md-6 col-sm-36"
            placeholder="Ex : 75001"
            :required="meta.representantLegal?.adresse?.codePostal?.$status === PropertyStatus.Required"
            :alertLabel="meta.representantLegal?.adresse?.codePostal?.$messageErreurDirty!"
            :maxlength="5"
            deletable
            :readonly
            :disabled="representantLegalDisabled"
          />
          <WrapperInput
            id="field_59"
            v-model="communeRepresentantModel"
            label="Commune"
            class="col-8 col-md-12 col-sm-36"
            placeholder="Ex : Paris"
            :required="meta.representantLegal?.adresse?.commune?.$status === PropertyStatus.Required"
            :alertLabel="meta.representantLegal?.adresse?.commune?.$messageErreurDirty!"
            :maxlength="50"
            deletable
            :readonly
            :disabled="representantLegalDisabled"
          />
        </template>
      </div>
      <div class="form__bloc">
        <WrapperInputTelephone
          id="field_50"
          v-model="telRepresentantModel"
          label="Téléphone"
          :required="meta.representantLegal?.representant?.telephone?.$status === PropertyStatus.Required"
          :alertLabel="meta.representantLegal?.representant?.telephone?.$messageErreurDirty!"
          class="col-6 col-md-12 col-sm-36"
          :placeholder="PLACEHOLDER_TEL"
          deletable
          :readonly
          :disabled="representantLegalDisabled"
        />
        <WrapperInput
          id="field_60"
          v-model="emailRepresentantModel"
          label="Email"
          hint="64 caractères maximum"
          class="col-12 col-md-18 col-sm-36"
          placeholder="nom.prenom@email.fr"
          :required="meta.representantLegal?.representant?.email?.$status === PropertyStatus.Required"
          :alertLabel="meta.representantLegal?.representant?.email?.$messageErreurDirty!"
          :maxlength="64"
          deletable
          :readonly
          :disabled="representantLegalDisabled"
        />
      </div>
    </template>
  </FormContainer>
</template>

<script setup lang="ts">
  import { inject } from 'vue'
  import { storeToRefs } from 'pinia'
  import { useDemandeCAPPStore } from '@/features/interface/demande/capp/useDemandeCAPPStore'
  import { CAPP_ACTIONS, type CappActions } from '@/features/interface/demande/capp/DemandeCAPP.type'
  import { OuiOuNon } from '@/features/interface/shared/tools'
  import { PropertyStatus } from '@/features/domaine/property-status/PropertyStatus'
  import { FormContainer, LABEL_NUMERO_VOIE, PLACEHOLDER_TEL } from '@/features/interface/demande/shared'

  const store = useDemandeCAPPStore()
  const { setupFieldWithKey } = store
  const { meta, model, readonly } = storeToRefs(store)

  const { estMemeAddresseRepresentantLegal, representantLegalDisabled } = inject<CappActions>(CAPP_ACTIONS)!

  const voieModel = setupFieldWithKey<string>('representantLegal.adresse.voie', true)
  const complementAdresseRepresentantModel = setupFieldWithKey<string>('representantLegal.adresse.complement', true)
  const codePostalRepresentantModel = setupFieldWithKey<string>('representantLegal.adresse.codePostal', true)
  const communeRepresentantModel = setupFieldWithKey<string>('representantLegal.adresse.commune', true)
  const telRepresentantModel = setupFieldWithKey<string>('representantLegal.representant.telephone', true)
  const emailRepresentantModel = setupFieldWithKey<string>('representantLegal.representant.email', true)
</script>
